import { Code } from "./enums/code.enum";

export class ServiceCallback<T = null> {
  public readonly messages: string[] = [];
  constructor(public readonly code: Code, msg: string = null, public readonly content:T = null) {
    if(msg) {
      this.messages.push(msg);
    }

    if (!this.isSuccess()) {
      let error = `An unexpected error ${this.code} append \n ${Code[this.code]}`
      if(this.messages[0]) {
        error += '\n' + this.messages[0];
      }
      console.error(error);
    }
  }

  addMessage(msg: string) {
    this.messages.push(msg);
  }

  isSuccess(): boolean {
    return this.code == Code.Success || this.code == Code.NoContent;
  }

  getMessage(): string {
    return this.messages.join('\n');
  }
}
